import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ActivateSmsDripSequence as ActivateSmsDripSequenceMutation,
    ActivateSmsDripSequenceVariables,
    SmsDripSequenceActivateInput,
} from 'nutshell-graphql-types';

import ACTIVATE_SMS_DRIP_SEQUENCE from '../mutations/activate-sms-drip-sequence.graphql';

export const useActivateSmsDripSequence = (): {
    activateSmsDripSequence: (arg1: SmsDripSequenceActivateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [activateSmsDripSequence, {loading, error}] = useMutation<
        ActivateSmsDripSequenceMutation,
        ActivateSmsDripSequenceVariables
    >(ACTIVATE_SMS_DRIP_SEQUENCE);

    return {
        activateSmsDripSequence: (input: SmsDripSequenceActivateInput) =>
            activateSmsDripSequence({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
